import React from 'react';
import PropTypes from 'prop-types';
import { HeaderContainter, Ask, Chevron } from './styles';

const HeaderComponent = ({
  text,
  isOpen,
  device = 'desktop',
  onClick = () => {},
  isMenu = false,
  textColor = 'black',
  borderColor = 'midDarkGray',
  width = '100%',
  height = '48px',
  marginLeft = '13px',
  marginTop = '3px',
  chevronWidth = '21px',
  chevronHeight = '16px'
}) => {
  return (
    <HeaderContainter
      isOpen={isOpen}
      onClick={onClick}
      isMenu={isMenu}
      borderColor={borderColor}
      width={width}
      height={height}
    >
      <Ask
        device={device}
        data-panel='dropDown-title'
        isMenu={isMenu}
        textColor={textColor}
        marginTop={marginTop}
        marginLeft={marginLeft}
      >
        {text}
      </Ask>
      <Chevron isOpen={isOpen} data-panel='dropDown-footerChevron' width={chevronWidth} height={chevronHeight} />
    </HeaderContainter>
  );
};

HeaderComponent.propTypes = {
  text: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default HeaderComponent;
